import React from "react"
import S from "./styled"

const Ftr = () => {
  return (
    <S.SectionContainer>
      <div>
        <p className="subhdg">
          <strong>Login Issues?</strong> Contact our Membership Coordinator at{" "}
          <a href="mailto:info@palmbeachbar.org">info@palmbeachbar.org</a> or
          561-687-2800.
        </p>

        <p className="subhdg" style={{ marginTop: "0" }}>
          <strong>Billing Questions?</strong> Reach our Bookkeeper at{" "}
          <a href="mailto:info@palmbeachbar.org">info@palmbeachbar.org</a> or
          561-687-2800.
        </p>

        <small>
          <span>©</span>
          <span>
            2021-25, Palm Beach County Bar Association. All Rights Reserved.
          </span>
        </small>
      </div>
    </S.SectionContainer>
  )
}

export default Ftr
